<template>
  <!-- 공지문 url 연결 예정 btn -->
  <div class="osResContent txtC padTX">
    
    <!-- 팝업 button onclick class 변경-->
    <div class="cc-btn" v-if="layers.abc == '' | isLogin "><button href="#" @click="$emit('reserve')" class="osResBtn01L" style="max-width: 337px; width:96%;" v-bind:style="joinButtonColor">예약 하기</button></div>
    <div class="cc-btn" v-if="layers.abc != '' | isLogin "><button href="#" @click="$emit('cancel')" class="osResBtn01L" :class="{'marTML' : isLogin}" style="max-width: 337px; width:96%;" v-bind:style="joinButtonColor">예약 취소</button></div>
    
    <div class="cc-btn" v-if="layers.abc != '' | isLogin "><button href="#" @click="$emit('check')" class="osResBtn01L marTML" style="max-width: 337px; width:96%;" v-bind:style="joinButtonColor">예약 확인</button></div>
    <!-- 
    <div class="cc-btn" v-if="isLogin "><button href="#" @click="$emit('amwayhome')" class="osResBtn01L marTML" style="max-width: 337px; width:96%;" v-bind:style="joinButtonColor">Amway Homepage</button></div>
    -->
    
  </div>
  <!-- //공지문 url 연결 예정 btn -->
</template>

<script>
export default {
  name: "artistryMakeoverJoin",
  props: ['login', 'layers'],
  computed : { 
    // 부모창에 휴대폰번호 형태로 제공 
    isLogin() { 
      return (!this.login)
    },
    // 신청하기 버튼에 대한 Style 효과 처리 
    joinButtonColor() {
      return (this.isLogin ? {'background-color': 'rgb(189 189 189)', 'color': '#000'} : {'background-color': '#000', 'color': '#fff'} ) 
    }
  },
  
};
</script>
<style scoped>
@import "../css/font_kr.css";
</style>


// WEBPACK FOOTER //
// src/views/artistry/makeover/components/join.vue